import { render, staticRenderFns } from "./ImportForm.vue?vue&type=template&id=4dd090b2&"
import script from "./ImportForm.vue?vue&type=script&lang=ts&"
export * from "./ImportForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm})
